import { deletePolicyTerms } from "actions/Utilities/Policy";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "components/toastNotification";

const useDeletePolicyTerm = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation((ids: string[]) => deletePolicyTerms(ids), {
    onSuccess: () => {
      queryClient.invalidateQueries(["GetTerms"]);
      toast.fire("Success", "Term were deactivated successfully", "success");
    },
    onError: () => {
      toast.fire(
        "Bulk deactivation of Term failed",
        "Server Error: Cannot deactivate Term",
        "error"
      );
    },
  });

  return mutate;
};
export default useDeletePolicyTerm;
